export const menuKeyDashboard = "/dashboard";

export const menuKeyPasswordChange = "/pwd-change";

export const menuKeyLogout = "/logout";

export const menuKeyLogsExpl = "/logs-expl";

export const menuKeyOrdersExpl = "/orders-expl";

export const menuKeyOrderView = "/order-view/:id";
